import { PATH } from './path';

export const BREAD_CRUMB = {
  [PATH.PRODUCT_OPERATING]: [{ title: '상품 관리' }, { title: '운영 상품 조회' }],
  [PATH.PRODUCT_REGISTER]: [{ title: '상품 관리' }, { title: '상품 등록/수정' }],
  [PATH.PRODUCT_MAPPING]: [{ title: '상품 관리' }, { title: '상품 판매처 매핑' }],
  [PATH.RECEIVE_REQUESTS]: [{ title: '입고 관리' }, { title: '입고 요청 관리' }],
  [PATH.RECEIVE_STATUS]: [{ title: '입고 관리' }, { title: '입고 현황' }],
  [PATH.RECEIVE_REPORT]: [{ title: '입고 관리' }, { title: '입고 리포트 관리' }],
  [PATH.STOCK_SKU]: [{ title: '재고 관리' }, { title: '상품별 조회' }],
  [PATH.STOCK_DATE]: [{ title: '재고 관리' }, { title: '유통기한별 조회' }],
  [PATH.STOCK_RELEASE]: [{ title: '재고 관리' }, { title: '반출 요청 관리' }],
  [PATH.SETTLEMENT_STORAGE]: [{ title: '정산 관리' }, { title: '보관비 조회' }],
  [PATH.ORDER_ORDERS]: [{ title: '출고 주문 관리' }, { title: '출고 주문 조회' }],
  [PATH.CLAIM_RETURN]: [{ title: '반품 교환 관리' }, { title: '반품 신청/조회' }],
  [PATH.CLAIM_EXCHANGE]: [{ title: '반품 교환 관리' }, { title: '교환 신청/조회' }],
  [PATH.DELIVERY_AGENCY_ORDER]: [{ title: '배송대행 관리' }, { title: '배송 주문 관리' }],
  [PATH.DELIVERY_AGENCY_TRACKING]: [{ title: '배송대행 관리' }, { title: '운송장 관리' }],
  [PATH.VENDER_CONFIRM]: [{ title: '화주사 정보 관리' }, { title: '화주사 정보' }],
  [PATH.VENDER_SUPPLIER]: [{ title: '화주사 정보 관리' }, { title: '공급사 관리' }],
};
